import { Provider } from 'react-redux';
import { store } from './store/AppStore';
import MainContentWrapper from './App';
import './index.scss';

const ControlPlaneWrapper = () => (
  <div className="control-plane-container">
    <Provider store={store}>
      <MainContentWrapper className="container m-auto" />
    </Provider>
  </div>
);

export default ControlPlaneWrapper;
